/**
 * @author @klknv
 */

const isStage = process.env.NODE_ENV === 'production' && window.location.hostname.includes('stage')

export default isStage
